/**
 * Kunjaree cart page — auto-apply FIRST10 on load (no full-page redirect).
 */
(function(global) {
  'use strict';

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function initCartPagePromo() {
    if (!isCartPage() || !global.KunjareeCartDiscount) return;
    if (typeof KunjareeCartDiscount.autoApplyPromoOnCartPage === 'function') {
      KunjareeCartDiscount.autoApplyPromoOnCartPage();
    }
  }

  document.addEventListener('DOMContentLoaded', initCartPagePromo);
})(window);
